import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puede } from "../../../../permisos/permisos";

function ListadoMaquinas() {
  const { user } = useContext(AuthContext);
  const URL_MAQUINAS = process.env.REACT_APP_URL_MAQUINAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [maquinas, setMaquinas] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState(null);

  const [nombre, setNombre] = useState("");
  const [clave, setClave] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [capacidad, setCapacidad] = useState(0);
  const [estado, setEstado] = useState("Activa");

  useEffect(() => { getMaquinas(); }, []);
  function getMaquinas() {
    axios.get(URL_MAQUINAS, headers).then((r) => setMaquinas(r.data)).catch((e) => console.log(e));
  }

  function clear() {
    setIdEdit(null); setNombre(""); setClave(""); setDescripcion(""); setCapacidad(0); setEstado("Activa");
  }
  function abreNuevo() { clear(); toggle(); }
  function abreEdit(a) {
    setIdEdit(a._id); setNombre(a.nombre); setClave(a.clave || ""); setDescripcion(a.descripcion || "");
    setCapacidad(a.capacidad || 0); setEstado(a.estado || "Activa"); toggle();
  }

  function guardar() {
    const body = { nombre, clave, descripcion, capacidad: Number(capacidad), estado };
    const req = idEdit
      ? axios.patch(`${URL_MAQUINAS}/${idEdit}`, body, headers)
      : axios.post(URL_MAQUINAS, body, headers);
    req
      .then(() => {
        axios.post(URL_LOGS, { tipo: idEdit ? "Editar Maquina" : "Crear Maquina", detalle: nombre, user: user.id }, headers);
        toggle();
        Swal.fire("Good job!", "Guardado con exito", "success");
        window.location.reload();
      })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data : error}` }));
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "catalogos.maquinas.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-industry" style={{ marginRight: 8, color: "#0ea5e9" }} />
                  Máquinas
                </h3>
                <p className="page-subtitle">Catálogo de máquinas</p>
              </div>
              <div className="page-actions">
                {puede(user, "catalogos.maquinas.crear") && (
<Button size="sm" color="success" onClick={abreNuevo}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nueva Máquina
                </Button>
)}
              </div>
            </div>
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Nombre</th>
                  <th className="tituloTabla">Clave</th>
                  <th className="tituloTabla">Capacidad</th>
                  <th className="tituloTabla">Estado</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {maquinas.map((a) => (
                  <tr key={a._id}>
                    <td>{a.nombre}</td>
                    <td>{a.clave}</td>
                    <td>{a.capacidad}</td>
                    <td>{a.estado}</td>
                    <td>
                      {puede(user, "catalogos.maquinas.editar") && (
<Button color="info" size="sm" onClick={() => abreEdit(a)}>
                        <i className="far fa-edit"></i>
                      </Button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      <Modal size="md" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-industry" style={{ marginRight: 8, color: "#0ea5e9" }} />
          {idEdit ? "Editar" : "Nueva"} Máquina
        </ModalHeader>
        <ModalBody>
          <Label>Nombre *</Label>
          <Input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
          <br />
          <Row>
            <Col md={6}>
              <Label>Clave</Label>
              <Input type="text" value={clave} onChange={(e) => setClave(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>Capacidad</Label>
              <Input type="number" value={capacidad} onChange={(e) => setCapacidad(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Label>Estado</Label>
          <Input type="select" value={estado} onChange={(e) => setEstado(e.target.value)}>
            <option>Activa</option>
            <option>Mantenimiento</option>
            <option>Baja</option>
          </Input>
          <br />
          <Label>Descripción</Label>
          <Input type="textarea" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoMaquinas;
